(function () {
	'use strict';
	angular.module('app.core')
		.controller('supersetDashboard', supersetDashboard);

	function supersetDashboard($state, $rootScope, $scope, storeService, leanTableConfigService, navigationService, $experiments, $http, tableService) {
		this.reportSettingsId = $state.params.id.trim();
		var reportSettingsId = this.reportSettingsId;
		var unsubscribe;
		var originalTitle;
		globalReportName = reportSettingsId;
		leanTableConfigService.setReportSettingsId(reportSettingsId);
		leanTableConfigService.getConfig(null, 'Superset', 'customer', null, storeService.getState().adminConfig.factory.id);

		function init() {
			$scope.dashboardView = _.cloneDeep(storeService.getState().reportSettings);
			$scope.model = storeService.getState().reportSettings;
			originalTitle = $scope.dashboardView.reportName;
			$scope.dashboardView['isEmbeddedDashboard'] = true;
			unsubscribe = storeService.subscribe(function () {
				var state = storeService.getState();
				if (state.previousAction.type === 'report-settings/fetch-error') {
					unsubscribe();
					storeService.loadMyViews(globalConfig.factory.id).then(function (response) {
						var state;
						var dashboards = response.data && response.data.filter(function (view) {
							return view.viewType === 'dashboards';
						});
						if (dashboards && dashboards.length) {
							state = navigationService.getStateForDashboard(dashboards[0]);
						} else {
							state = { sref: 'app.dashboard.new-dashboard' };
						}
						$state.go(state.sref, state.params);
					});
					return;
				}

				if (state.reportSettings.reportName !== originalTitle && !_.isEmpty(state.reportSettings.config)) {
					if (state.reportSettings.baseReportName !== 'Superset') {
						unsubscribe();
						return;
					}

					originalTitle = state.reportSettings.reportName;
					$scope.dashboardView = _.cloneDeep(state.reportSettings);
					$scope.model = state.reportSettings;
					$scope.dashboardView['isEmbeddedDashboard'] = true;

					getEmbedId(state.reportSettings.config.supersetDashboardId);

					var trackingReportName = 'Superset dashboard (id: ' + state.reportSettings.config.supersetDashboardId + '): ' + state.reportSettings.config.supersetDashboardTitle;
					tableService.trackPageView(trackingReportName, []);
				}
			});
		}

		function getGuestToken(embedId) {
			return $http.get('/api/2/superset/getGuestToken/embedId/' + embedId)
				.then(getGuestTokenComplete)
				.catch(getGuestTokenFailed);

			function getGuestTokenComplete(response) {
				return response.data.token;
			}

			function getGuestTokenFailed(error) {
				return error;
			}
		}

		function getEmbedId(supersetDashboardId) {
			return $http.get('/api/2/superset/getEmbedIdAndUrl/dashboardId/' + supersetDashboardId)
				.then(embedSupersetDashboard)
				.catch(embedFailed);

			function embedSupersetDashboard(response) {
				supersetEmbeddedSdk.embedDashboard({
					id: response.data.uuid,
					supersetDomain: response.data.domain,
					mountPoint: document.getElementById('superset-dashboard'),
					fetchGuestToken: function () { return getGuestToken(response.data.uuid); },
					dashboardUiConfig: {
						hideTitle: true,
						hideChartControls: false,
						hideTab: false,
						filters: {
							visible: true,
							expanded: true
						},
						urlParams: {
							isSuperAdmin: response.data.isSuperAdmin,
							databaseServer: response.data.databaseServer,
							databaseName: response.data.databaseName
						}
					}
				});
			}

			function embedFailed(error) {
				return error;
			}
		}

		init();
	}
})();
